import React from "react";
import { useParams, Link } from "react-router-dom";
import ClientProjectView from "./ClientProjectView";

export default function ClientProjectDetail() {
  const { projectId } = useParams();

  return (
    <div>
      <div className="text-xs text-muted-foreground mb-3">
        <Link to="/dashboard/client" className="hover:underline">
          Overview
        </Link>{" "}
        / Project
      </div>
      <ClientProjectView projectId={projectId} />
    </div>
  );
}
